import { render, staticRenderFns } from "./Page-Prescription.vue?vue&type=template&id=5db5ace5"
import script from "./Page-Prescription.vue?vue&type=script&lang=js"
export * from "./Page-Prescription.vue?vue&type=script&lang=js"
import style0 from "./Page-Prescription.vue?vue&type=style&index=0&id=5db5ace5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports